import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {
    CustomerProfileDataSource,
    CustomerProfileTabApiData,
} from "~/components/entityProfile/customerProfileDataSource/types";

/** Placeholder for live customer profile APIs — swap in when endpoints are ready. */
export const liveCustomerProfileDataSource: CustomerProfileDataSource = {
    fetchTabData: async (_args: {customerId: Uuid}): Promise<CustomerProfileTabApiData> => {
        throw new Error("Live customer profile API is not implemented yet.");
    },
};
